/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-direct-mutation-state */

import React from 'react';

import S from 'constants/string.const';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';

import PopupFooter, {
  POPUP_FOOTER_VARIANTS,
} from 'clientCommunications/components/Clients/ConfirmationModal/PopupFooter';
import PopupHeader from 'clientCommunications/components/Clients/ConfirmationModal/PopupHeader';

import CN from './PopupWith2Buttons.module.scss';

const TEXT_BILLING_INFO = `Ooops, it looks like you haven${S.apos}t entered any billing details yet`;

class PopupWith2Buttons extends React.Component {
  static defaultProps = {
    billing: false,
    onlineBilling: false,
    beforeSend: false,
    exit: false,
    finalAgreeToSend: false,
    consultation: false, // eslint-disable-line react/default-props-match-prop-types
    gotoBilling: () => {},
    gotoOnlineBooking: () => {},
    doSend: () => {},
    setFinalAgreeToSend: () => {},
    sending_allowed: false,
    openPurchaseModal: () => {},
    uniqNote: '',
    optoutNote: '',
    numClientsToBeSentOptout: 0,
    duplicated: 0,
    isFetching: false,
    messageSent: false,
    fromAppointment: false,
    isReceptionist: false,
    onlineBooking: false,
    isModalAction: false,
    history: null,
    sendSMSVisibility: '', // eslint-disable-line react/default-props-match-prop-types
  };

  constructor(props) {
    super(props);
    this.state = {
      disabled: false,
      displayLoading: !props.exit && !props.onlineBooking,
      timer: null,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.popupContent && !nextProps.isFetching) {
      this.setState({ displayLoading: false });
    }
  }

  componentDidUpdate() {
    clearTimeout(this.state.timer);
  }

  componentWillUnmount() {
    clearTimeout(this.state.timer);
    const { history } = this.props;
    if (this.props.exit && this.props.isModalAction && history) {
      const oldpath = history.location.pathname;
      const newPath = `${oldpath.split('communications/')[0]}day/today`;
      history.push({ pathname: newPath });
    }
  }

  closeBillingPopup = () => {
    this.props.closePopup('billingPopupOpen');
  };
  closeBeforeSendPopup = () => {
    this.props.closePopup('beforeSendPopupOpen');
    this.props.showPopup('smsComposeModalOpen');
  };
  closeExitPopup = () => {
    this.props.closePopup('exitPopupOpen');
  };
  closeExitAndComposePopup = () => {
    if (this.props.handleOpen) {
      this.props.handleOpen(false, 'exit-totally');
    }
    // handleOpen will cause SmsButton to re-render, willReceiveProps set smsComposeModalOpen to true
    // in ClientLayout, so wait a minute for that to happen first
    setTimeout(() => {
      this.props.closePopup('exitPopupOpen');
      this.props.closePopup('smsComposeModalOpen');
      this.props.closePopup('beforeSendPopupOpen');
    }, 1000);
  };

  closeExitAndSendSms = () => {
    // if (this.state.disabled || !this.props.finalAgreeToSend) {
    //   return;
    // }
    this.setState({ disabled: true, displayLoading: true });
    if (this.props.doSend) {
      this.props.doSend();
    }

    // wait for the sent message api call befor close send popup
    // otherwise the whole thing will close before sent popup appear
    const interval = setInterval(() => {
      if (this.props.messageSent !== null && !this.props.isFetching) {
        this.setState({ displayLoading: false });
        document.querySelector('.sms-title div').innerText = 'Sorry, your message were not sent, please try again';
        document.querySelector('.uniq-note').innerText = '';
        clearInterval(interval);
        setTimeout(() => {
          this.props.closePopup('beforeSendPopupOpen');
          if (this.props.handleOpen) {
            this.props.handleOpen(false);
          }
        }, 3000);
      }
    }, 500);
  };
  closeOnlineBookingPopup = () => {
    this.props.closePopup('onlineBookingPopupOpen');
    this.props.showPopup('smsComposeModalOpen');
  };

  render() {
    let leftButtonTitle = 'BACK';
    let rightButtonTitle = 'CONTINUE';
    let footerVariant = POPUP_FOOTER_VARIANTS.DEFAULT;
    let leftButtonClick = () => {};
    let rightButtonClick = () => {};
    let footerInfo = 'info';
    let withCheckBox = false;

    const duplicated = this.props.duplicated || 0;
    const numClientsToBeSentOptout = this.props.numClientsToBeSentOptout || 0;

    if (this.props.onlineBilling) {
      leftButtonTitle = 'GO BACK';
      rightButtonTitle = 'GO TO BILLING';
      footerVariant = POPUP_FOOTER_VARIANTS.BILLING;
      leftButtonClick = this.closeBillingPopup;
      rightButtonClick = this.props.gotoBilling ? this.props.gotoBilling : () => {};
      footerInfo = '';
    } else if (this.props.billing) {
      leftButtonTitle = 'GO BACK';
      rightButtonTitle = 'GO TO BILLING';
      footerVariant = POPUP_FOOTER_VARIANTS.BILLING;
      leftButtonClick = this.closeBillingPopup;
      rightButtonClick = this.props.gotoBilling ? this.props.gotoBilling : () => {};
      footerInfo = <div className={CN.footerText}>In order to send SMS you’ll need to enter card details</div>;
    } else if (this.props.beforeSend) {
      leftButtonTitle = 'GO BACK';
      rightButtonTitle = this.props.sending_allowed ? 'SEND TEXT' : 'GET MORE SMS CREDIT';
      footerVariant = this.props.sending_allowed ? POPUP_FOOTER_VARIANTS.ONLINE : POPUP_FOOTER_VARIANTS.DEFAULT;
      leftButtonClick = this.closeBeforeSendPopup;
      rightButtonClick = this.props.sending_allowed ? this.closeExitAndSendSms : this.props.openPurchaseModal;
      footerInfo = '';
      withCheckBox = false; // removed this checkbox and make SEND SMS button independent of it
    } else if (this.props.exit) {
      leftButtonTitle = 'NO, GO BACK';
      rightButtonTitle = 'YES, EXIT';
      footerVariant = POPUP_FOOTER_VARIANTS.EXIT;
      leftButtonClick = this.closeExitPopup;
      rightButtonClick = this.closeExitAndComposePopup;
      footerInfo = '';
    } else if (this.props.onlineBooking) {
      leftButtonTitle = 'GO BACK';
      rightButtonTitle = 'GO TO ONLINE BOOKING';
      footerVariant = POPUP_FOOTER_VARIANTS.ONLINE;
      leftButtonClick = this.closeOnlineBookingPopup;
      rightButtonClick = this.props.gotoOnlineBooking ? this.props.gotoOnlineBooking : () => {};
      footerInfo = (
        <div className={CN.footerText}>
          To add a booking link you need to first enable online booking, to do this go to the menu and then Online
          booking and Payments
        </div>
      );
    }
    const os = `popup-2-button animated zoomIn`;
    const className = this.props.fromAppointment
      ? `dialog-container-marketing fromAppointment`
      : `dialog-container-marketing fromMarketing`;

    return (
      <div data-bem="PopupWith2Buttons" className={className}>
        <div className={os}>
          <PopupHeader onClose={alwaysNoop} style={{ borderRadius: '4px' }}>
            {this.state.displayLoading && (
              <div className="spinner-container bgr-white">
                {this.props.onlineBilling ? (
                  TEXT_BILLING_INFO
                ) : (
                  <div>
                    <div className="load-spinner" />
                    <span className="spinner-text">Loading...</span>
                  </div>
                )}
              </div>
            )}
            {!this.state.displayLoading && (
              <div className="flex-center">
                <div className="modal-content">
                  <div className="sms-title">{this.props.popupContent}</div>
                  {numClientsToBeSentOptout > 0 && <p className="uniq-note text-smaller">{this.props.optoutNote}</p>}
                  {duplicated > 0 && <p className="uniq-note">{this.props.uniqNote}</p>}
                </div>
              </div>
            )}
          </PopupHeader>
          {rightButtonClick && (
            <PopupFooter
              leftButtonTitle={leftButtonTitle}
              rightButtonTitle={rightButtonTitle}
              leftButtonClick={leftButtonClick}
              rightButtonClick={rightButtonClick}
              disabled={this.state.disabled}
              footerInfo={footerInfo}
              withCheckBox={withCheckBox}
              setFinalAgreeToSend={this.props.setFinalAgreeToSend ? this.props.setFinalAgreeToSend : () => {}}
              finalAgreeToSend={this.props.finalAgreeToSend ? this.props.finalAgreeToSend : false}
              fromAppointment={this.props.fromAppointment}
              isReceptionist={this.props.isReceptionist}
              sendSMSVisibility={this.props.sendSMSVisibility}
              type={footerVariant}
            />
          )}
        </div>
      </div>
    );
  }
}

export default PopupWith2Buttons;
